var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7825 5.03568L10.575 2.60609C9.88792 2.20943 9.03792 2.20943 8.34375 2.60609L4.14333 5.03568C3.45625 5.43234 3.03125 6.16901 3.03125 6.96943V11.8144C3.03125 12.6078 3.45625 13.3444 4.14333 13.7482L8.35083 16.1778C9.03792 16.5744 9.88792 16.5744 10.5821 16.1778L14.7896 13.7482C15.4767 13.3515 15.9017 12.6148 15.9017 11.8144V6.96943C15.8946 6.16901 15.4696 5.43943 14.7825 5.03568ZM11.0567 10.3836L10.32 10.8086L9.58333 11.2336C8.64125 11.779 7.86917 11.3328 7.86917 10.2419V9.39193V8.54193C7.86917 7.45109 8.64125 7.00484 9.58333 7.55026L10.32 7.97526L11.0567 8.40026C11.9987 8.94568 11.9987 9.83818 11.0567 10.3836Z",
    fill: "url(#paint0_linear_3561_18950)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3561_18950",
    x1: 9.46646,
    y1: 2.30859,
    x2: 9.46646,
    y2: 16.4753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.0726206310b6659f1f56090346368c52.svg";
export { ForwardRef as ReactComponent };